/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { UsertypeApi } from '../api/usertype.api';
import { switchMap, map } from 'rxjs/operators';
import { UsertypeData, Usertype } from '../../../interfaces/masters/usertype';

@Injectable()
export class UsertypeService extends UsertypeData {

  constructor(private api: UsertypeApi) {
    super();
  }

//   fireRequest(data: Department, method: string) {
//     const links = data.links
//         ? data.links.find(x => x.method === method)
//         : null;
//     switch (method) {
//         case 'DELETE': {
//             return this.api.delete(links.href);
//         }
//         case 'POST': {
//             return this.api.add(links.href,data);
//         }
//         case 'PUT': {
//             return this.api.update(links.href, data);
//         }
//         default: {
//             console.log(`${links.method} not found!!!`);
//             break;
//         }
//     }
// }

  list(url: string): Observable<Usertype[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<Usertype>{
      return this.api.getById(url);
  }

  create(url: string, data:Usertype): Observable<Usertype> {
    return this.api.add(url,data);
  }

  update(url: string, data:Usertype): Observable<Usertype> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }

  getall(url: string): Observable<any> {
    return this.api.getall(url);
  }
}
